import React from 'react'
import times from 'lodash/times'
import concat from 'lodash/concat'
import FormSelect from 'components/forms/bases/FormSelect'

const ColumnWidthSelector = ({
  ...props,
}) => {
  return (
    <FormSelect
      label="columns"
      options={concat([''], times(12, (index) => index + 1))}
      {...props}
    />
  )
}

ColumnWidthSelector.propTypes = {}
ColumnWidthSelector.defaultProps = {}

export default ColumnWidthSelector



// WEBPACK FOOTER //
// ./src/components/forms/ColumnWidthSelector.js